import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'

import { stateComponentComplete } from '../../../models'
import { sendDataLayer } from '../../../helpers'

const ContentThree = () => {
    const location = useLocation()
    const [render, setRender] = useState<stateComponentComplete>({ ready: false})
    const [source, setSource] = useState<string>('default')

    useEffect(() => {
        if (render.ready) sendDataLayer('onload-pager', location.pathname)
        setRender({ ready: true})
    
        // Extraer parámetro source de la URL
        const params = new URLSearchParams(location.search)
        const src = params.get('source')
        if(src === 'whats') {
            setSource('whats')
        } else if(src === 'email') {
            setSource('email')
        } else {
            setSource('default')
        }
    }, [location.search, location.pathname, render.ready]) 

    //Se definen las imagenes según su fuente
    const imageSrcMap: Record<string, string> = {
        whats: '/assets/imgWa.webp',
        email: '/assets/imgCorreo.webp',
        default: '/assets/pareja-act.webp'
    }

    return (
        <main className='container_content_three'>
            <div className='img_three'>
                    <img
                        src={imageSrcMap[source]}
                        alt='pareja-cenando'
                        className='img-red'
                    />
                </div>
            <section className='container_text_three'>
                <h1 className='title_three'>Activa tu suscripción</h1>
                <p className='p_three'>
                    Como cliente de Profuturo tienes 
                    <span className='span_text'> 12 meses de Soy+ sin costo. </span> 
                    No dejes que se pierdan tus beneficios y experiencias exclusivas.<br /><br />
                    <span className='span_text'>Activa tu acceso creando tu contraseña </span> 
                    y disfruta lo que es tuyo.
                </p>
            </section>
        </main>
    )
}

export default ContentThree